import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import Chart from 'chart.js/auto';
import { MainService } from 'src/app/main/services/main.service';
import { DateAdapter } from '@angular/material/core';
import { SharedService } from '../../services/shared-service/shared.service';
import { SellService } from 'src/app/main/modules/sell-management/service/sell.service';
import { MatDatepickerInputEvent, MatDateRangePicker } from '@angular/material/datepicker';

export interface DialogData {
  id: any;
}

@Component({
  selector: 'app-new-date-filter',
  templateUrl: './new-date-filter.component.html',
  styleUrls: ['./new-date-filter.component.scss']
})
export class NewDateFilterComponent {


  @ViewChild(MatSelect) matSelect: MatSelect;
  @ViewChild(MatMenu) menu: MatMenu;
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @Input() type: any;
  @Input() from: any;
  @Input() btnName: string = '';
  @Input() pageName: string = '';
  @Input() refreshCall: EventEmitter<void>;
  @Output() dateApplied = new EventEmitter<void>();
  @ViewChild('startPicker') startPicker!: MatDateRangePicker<Date>;
  @ViewChild('endPicker') endPicker!: MatDateRangePicker<Date>;
  get startControl() { return this.range.get('start'); };
  get endControl() { return this.range.get('end'); };

  currentDate: Date;
  range: any;
  csvStartDate: any = '';
  csvEndDate: any = '';
  cusEnd: Date;
  cusStart: Date;
  totalData: any = null;
  tableDate: any = null;
  selectedOption: string;
  selectedValue: any = null;
  selectedView: any = null;
  DatepickOpen: boolean = false;
  isDateApply: boolean = false;
  isEndDate: boolean = false;
  today: Date = new Date();
  payload = {
    start: '',
    end: ''
  }

  constructor(
    private alertService: AlertService,
    private authService: AuthService,
    public dialog: MatDialog,
    public mainService: MainService,
    private dateAdapter: DateAdapter<Date>,
    private sharedService: SharedService,
    public sellService: SellService,

  ) {
    this.currentDate = new Date();

    dateAdapter.setLocale("en-in");

    this.range = new FormGroup({
      start: new FormControl('', Validators.compose([])),
      end: new FormControl('', Validators.compose([])),
    });


  }

  dateOptions = [
    { label: 'Current Month', value: 'Current Month' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Current Quarter', value: 'Current Quarter' },
    { label: 'Last Quarter', value: 'Last Quarter' },
    { label: 'Current FY', value: 'Current FY' },
    { label: 'Last FY', value: 'Last FY' },
    { label: 'Custom Date', value: 'Custom Date' }
  ];

  onOptionChange(val: string) {
    this.calenderValue(val);
    if (val === 'Custom Date') {
      setTimeout(() => this.startPicker?.open(), 0);
    }
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  prevData() {
    this.selectedOption = this.selectedView;
    console.log(this.selectedOption);

    if (this.selectedOption === 'Custom Date') {
      this.DatepickOpen = true;

    } else {
      this.DatepickOpen = false;

    }
  };


  onClickHandler(): void {
    if (!this.isDateApply) {
      this.calenderValue('Current Month');
    } else {
      this.prevData();
    }
  }


  calenderValue(date: string) {
    const today = new Date();
    this.selectedOption = date;
    this.range.value.start = null;
    this.range.value.end = null;
    this.csvStartDate = null;
    this.csvEndDate = null;
    this.cusStart = null;
    this.cusEnd = null;
    console.log('calling');
    console.log(date);


    let startDate: Date;
    let endDate: Date;

    if (date === 'Current Month') {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of the current month
      this.DatepickOpen = false;
      this.cusStart = startDate;
      this.cusEnd = endDate;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    else if (date === 'Last Month') {
      const lastMonth = today.getMonth() - 1;
      startDate = new Date(today.getFullYear(), lastMonth, 1);
      endDate = new Date(today.getFullYear(), lastMonth + 1, 0); // last day of last month
      this.DatepickOpen = false;
      this.cusStart = startDate;
      this.cusEnd = endDate;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    else if (date === 'Current Quarter') {
      const currentMonth = today.getMonth();
      const quarter = Math.floor(currentMonth / 3);
      startDate = new Date(today.getFullYear(), quarter * 3, 1);
      endDate = new Date(today.getFullYear(), (quarter + 1) * 3, 0);
      this.DatepickOpen = false;
      this.cusStart = startDate;
      this.cusEnd = endDate;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    else if (date === 'Last Quarter') {
      const currentMonth = today.getMonth();
      let quarter = Math.floor(currentMonth / 3);
      if (quarter === 0) {
        quarter = 3;
        startDate = new Date(today.getFullYear() - 1, quarter * 3, 1);
        endDate = new Date(today.getFullYear(), 0, 0);
      } else {
        startDate = new Date(today.getFullYear(), (quarter - 1) * 3, 1);
        endDate = new Date(today.getFullYear(), quarter * 3, 0);
      }
      this.DatepickOpen = false;
      this.cusStart = startDate;
      this.cusEnd = endDate;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    else if (date === 'Current FY') {
      const currentYear = today.getFullYear();
      if (today.getMonth() + 1 < 4) {
        startDate = new Date(currentYear - 1, 3, 1);
        endDate = new Date(currentYear, 2, 31);
        this.cusStart = startDate;
        this.cusEnd = endDate;
        console.log('kk');
        this.DatepickOpen = false;

      } else {
        startDate = new Date(currentYear, 3, 1);
        endDate = new Date(currentYear + 1, 2, 31);
        console.log('kk2');
        this.DatepickOpen = false;

        this.cusStart = startDate;
        this.cusEnd = endDate;
      }
      this.DatepickOpen = false;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    else if (date === 'Last FY') {
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1; // JavaScript months are 0-based

      if (currentMonth < 4) { // If the current month is before April

        startDate = new Date(currentYear - 2, 3, 1); // 1st April two years ago
        endDate = new Date(currentYear - 1, 2, 31); // 31st March last year
      } else {

        startDate = new Date(currentYear - 1, 3, 1); // 1st April last year
        endDate = new Date(currentYear, 2, 31); // 31st March this year
      }

      this.DatepickOpen = false;
      this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
      this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

    }
    if (date === 'Custom Date') {
      this.range = new FormGroup({
        start: new FormControl(today, Validators.compose([Validators.required])),
        end: new FormControl(null, Validators.compose([Validators.required])),
      });

      this.cusStart = null;
      this.cusEnd = null;
      this.csvStartDate = null;
      this.csvEndDate = null;
      startDate = null;
      endDate = null;
      this.DatepickOpen = true;
    }

  }

  customDate() {
    if (!this.range.value.start) {
      this.alertService.warningDateAlert('You must choose a start date!').then(() => {
        this.startPicker.open();
      });
      return;
    };


    if (!this.range.value.end) {
      // this.alertService.warningDateAlert('You must choose a end date!').then(() => {
      // });

      this.startPicker.open();
      this.isEndDate = true;

      return;
    }

    const startDate = new Date(this.range.value.start);
    const endDate = new Date(this.range.value.end);
    this.csvStartDate = this.formatDateToYYYYMMDD(startDate);
    this.csvEndDate = this.formatDateToYYYYMMDD(endDate);

  }



  openCalendar() {
    this.matSelect.close();
    setTimeout(() => this.startPicker.open(), 0);
  }


  onStartDateChange(date: Date | null) {
    if (date) {
      this.csvStartDate = this.formatDateToYYYYMMDD(date);
    } else {
      this.csvStartDate = null;
    }
  }

  onEndDateChange(date: Date | null) {
    if (date) {
      this.csvEndDate = this.formatDateToYYYYMMDD(date);
    } else {
      this.csvEndDate = null;
    }
  }

  onStartDateInput(event: MatDatepickerInputEvent<Date>) {
    const d = event.value ? new Date(event.value) : null;

    if (d) {
      this.csvStartDate = this.formatDateToYYYYMMDD(d);
    }
  }


  onEndDateInput(event: MatDatepickerInputEvent<Date>) {
    const d = event.value;
    if (d) {
      this.csvEndDate = this.formatDateToYYYYMMDD(d);
    }
  }

  onStartPickerClosed() {
    const val = this.startControl?.value;
    if (val) {
      const date = val instanceof Date ? val : new Date(val);
      this.csvStartDate = this.formatDateToYYYYMMDD(date);

      if (this.csvStartDate) {
        setTimeout(() => this.endPicker.open(), 0);
      }

    }

  }

  onEndPickerClosed() {
    const val = this.endControl?.value;
    if (val) {
      const date = val instanceof Date ? val : new Date(val);
      this.csvEndDate = this.formatDateToYYYYMMDD(date);
    }
  }

  applyDate(selected: any = null) {
    this.isDateApply = true;
    this.selectedView = selected;
    this.DatepickOpen = false;

    let payload = {
      start: this.csvStartDate,
      end: this.csvEndDate,
    }

    this.payload = payload;

    this.sharedService.setDateFilter({ ...this.payload, from: this.from });

    this.dateApplied.emit();

    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }

  };


  get displayBtnName(): string {
    if (this.btnName && this.btnName.trim() !== '') {
      return this.btnName;
    } else {
      return 'Month And Year';
    }
  };



  formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  removeDateFilter() {
    this.DatepickOpen = false;
    this.selectedOption = null;
    this.selectedView = null;

    this.csvStartDate = '';
    this.csvEndDate = '';
    this.isDateApply = false;

    this.payload.start = this.csvStartDate;
    this.payload.end = this.csvEndDate,

      this.sharedService.setDateFilter({ ...this.payload, from: this.from, remove: true });

    this.stopPropagation(event);
  };

  ngOnInit() {

    this.sharedService.csvStartDate = this.csvStartDate;
    this.sharedService.csvEndDate = this.csvEndDate;

    this.payload.start = this.csvStartDate;
    this.payload.end = this.csvEndDate,
      this.sharedService.setDateFilter({ ...this.payload, from: this.from });
    console.log('refresh11');

    if (this.refreshCall) {
      this.refreshCall.subscribe(() => {
        this.csvEndDate = '';
        this.csvStartDate = '';
        this.isDateApply = false;
        this.selectedOption = null;
        this.selectedView = null;
        console.log('refresh');


        this.sharedService.csvStartDate = this.csvStartDate;
        this.sharedService.csvEndDate = this.csvEndDate;

        this.payload.start = this.csvStartDate;
        this.payload.end = this.csvEndDate,
          this.sharedService.setDateFilter({ ...this.payload, from: this.from });
      });
    }

    this.range.valueChanges.subscribe(val => {
      if (val?.end) {
        this.isEndDate = true;
      } else {
        this.isEndDate = false;
      }
    });

    if (this.pageName === 'dashboard') {

      this.calenderValue('Current FY');
      this.applyDate('Current FY');


    }
  }


  getFinancialYearDates(): { startDate: string; endDate: string } {
    const today = new Date();
    // If before April → current FY started last year
    const year = today.getMonth() + 1 < 4 ? today.getFullYear() - 1 : today.getFullYear();

    const start = new Date(year, 3, 1);       // April 1
    const end = new Date(year + 1, 2, 31);    // March 31 next year

    return {
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    };
  }

}
